/**
 * Central z-index scale.
 *
 * Use these constants everywhere instead of hard-coding numbers so that the
 * layering order is always visible and easy to change in one place.
 *
 * Layer order (low → high):
 *   content (0) → header (50) → sidebar (60) → drawer (65)
 *   → modal (70) → toast (80) → network-banner (100) → spotlight (200)
 */
export const Z = {
  /** Sticky page header */
  header: 50,
  /** Side navigation (mobile full-screen or desktop panel) */
  sidebar: 60,
  /** Side-panel drawers that slide in from an edge (e.g. TaskDrawer) */
  drawer: 65,
  /** Full-screen modal dialogs with backdrop */
  modal: 70,
  /** Undo / snackbar toasts */
  toast: 80,
  /** Network-status banner (always on top of UI) */
  network: 100,
  /** Spotlight overlays, floating pickers, error toasts */
  spotlight: 200,
} as const

export type ZKey = keyof typeof Z
